import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { LoginService } from '../../login/login.service';

@Injectable()
export class loggerInterceptor implements HttpInterceptor {
  constructor(private loginService: LoginService, private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    //On skip si on se log
    if (req.headers.has('Skip-Auth')) {
      return next.handle(req);
    }

    let dateTokenExpired = new Date(
      +this.loginService.lastTokenDate +
        JSON.parse(localStorage.getItem('token') ?? '""').expires_in * 1000
    );
    if (new Date() > dateTokenExpired && !['/login', '/'].includes(window.location.pathname)) {


      let dateRefreshTokenExpired = new Date(
        +this.loginService.loginRefreshTokenDate +
          JSON.parse(localStorage.getItem('token') ?? '""').refresh_expires_in * 1000
      );

      if (new Date() > dateRefreshTokenExpired) {
        this.router.navigateByUrl('');
      } else {
          this.loginService.getNewToken().subscribe((res) => {
            this.loginService.lastTokenDate = new Date();
            localStorage.setItem('token', JSON.stringify(res));
          }, (error) => {
            this.router.navigateByUrl('/no');
          });

      }

    }

    return next.handle(req);
  }
}
